export default __webpack_public_path__ + "static/media/twitter-DarkBlue.310ed4a1.png";